export type Config = {
  clientId: string;
  tenantId: string;
  authorityUri: string;
  redirectUri: string;
  tokenScopes: string[];
  cacheLocation: string;
  secureCookies: boolean;
  drillx_so_api_url: string;
  drillx_id3_api_url: string;
  drillx_wg_api_url: string;
  drillx_gm_depthlog_api_url: string;
  enableDebugLogs?: boolean;
  storeAuthStateInCookie?: boolean;
  env_id: string;
  instrumentationKey: string;
  apim_subscription_key: string;
  apim_trace: string;
  hotjar_site_id: string;
  app_version: string;
  drillx_lessons_learnt_url: string;
  drillx_common_backend: string;
};

export const EnvConfig: Config = {
  cacheLocation: 'localStorage',
  clientId: '{CLIENT_ID}',
  tenantId: '{TENANT_ID}',
  secureCookies: !!process.env.SECURE_COOKIES,
  drillx_so_api_url: '{DRILLX_SO_API_URL}',
  drillx_id3_api_url: '{DRILLX_ID3_API_URL}',
  drillx_wg_api_url: '{DRILLX_WG_API_URL}',
  drillx_gm_depthlog_api_url: '{DRILLX_GM_DEPTHLOG_API_URL}',
  redirectUri: '{REDIRECT_URI}',
  tokenScopes: [...('{AAD_BACKEND_SCOPE}'.split(',') ?? [])],
  enableDebugLogs: !!'{ENABLE_DEBUG_LOGS}',
  authorityUri: '{TENANT_AUTHORITY_URI}',
  drillx_lessons_learnt_url: '{DRILLX_LESSONS_LEARNT_URL}',
  drillx_common_backend: '{DRILLX_COMMON_BACKEND_URL}',
  env_id: '{ENV_ID}',
  instrumentationKey: '{APPLICATION_INSIGHTS_INSTRUMENTATION_KEY}',
  apim_subscription_key: '{APIM_SUBSCRIPTION_KEY}',
  apim_trace: '{APIM_TRACE}',
  hotjar_site_id: '{HOTJAR_SITE_ID}',
  app_version: '{APP_VERSION}',
};
